import { initializeApp, getApps, getApp } from 'firebase/app';
import { initializeFirestore, memoryLocalCache, getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Désactive le cache persistant (IndexedDB) pour éviter d'afficher des docs pré-publiés mis en cache
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const db = getApps().length > 1
  ? getFirestore(app)
  : initializeFirestore(app, { localCache: memoryLocalCache() });
// Ne pas tracker les browsers automatisés (Playwright, Selenium)
export const analytics = navigator.webdriver ? null : getAnalytics(app);
